import axios from '@axios';

const base = '/api/v1/prison-users';

export default {
  getUsers() {
    return axios.get(`${base}/managed-users`);
  },
  createUser(data) {
    return axios.post(`${base}/managed-users/register`, data);
  },
  deleteUser(userId) {
    return axios.post(`${base}/managed-users/delete/${userId}`);
  },
};
